<template>
  <div class="single">
    <div class="row">
      <label class="col-sm-3 control-label pt-10"> Pickup Date* </label>
      <div class="col-sm-8">
        <date-picker
          v-model="data.pickupDate"
          required
          :disabled-date="disabledDate"
        />
      </div>
    </div>

    <div class="row">
      <label class="control-label pt-10 col-sm-3"> Pickup Time* </label>
      <time-picker
        v-model="data.pickupTime"
        class="col-sm-8"
        required
        clearable
        format="hh:mm a"
        @blur="changePickupTime"
      >
        <template #comment>
          <span
            v-if="isShowTimeWarningMessage"
            class="help-block warning-message"
          >
            Please inform the rider that it may be hard to get a driver at this scheduled time.
          </span>
        </template>
      </time-picker>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },

  isShowTimeWarningMessage: {
    type: Boolean,
    default: false,
  },

  disabledDate: {
    type: Function,
    default: () => null,
  },
});

const changePickupTime = () => {
  emit('change-pickup-time', props.data.pickupTime);
};

const emit = defineEmits(['change-pickup-time']);
</script>
